var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children } from 'react';
import { Box, FlexGrid, StackView, Responsive } from '@telus-uds/components-web';
import _get from 'lodash/get';
import styled from 'styled-components';
import { VariantSelector, OnlineShopping } from '../..';
import { fromTablet } from '../../../constants/breakpoints';
import space from '../../../helpers/theme';
export var DeviceTopInfo = function (_a) {
    var children = _a.children;
    var childrenArray = Children.toArray(children);
    var variantSelector = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray.find(function (child) {
        var type = _get(child, 'type');
        return type === VariantSelector;
    });
    var onlineShopping = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray.find(function (child) {
        var type = _get(child, 'type');
        return type === OnlineShopping;
    });
    var filteredChildren = childrenArray === null || childrenArray === void 0 ? void 0 : childrenArray.filter(function (child) {
        var type = _get(child, 'type');
        return type !== OnlineShopping && type !== VariantSelector;
    });
    return (_jsxs(_Fragment, { children: [_jsx(Responsive, { min: "xs", max: "sm", children: _jsx(Box, { children: _jsxs(StackView, { space: 4, children: [variantSelector !== null && variantSelector !== void 0 ? variantSelector : null, filteredChildren, onlineShopping && _jsx(OnlineShoppingWrapper, { children: onlineShopping })] }) }) }), _jsx(Responsive, { min: "md", children: _jsx(FlexGrid, { limitWidth: false, gutter: false, children: _jsxs(FlexGrid.Row, { children: [_jsx(FlexGrid.Col, { md: 6, children: _jsx(Box, { right: 5, children: _jsxs(StackView, { space: 4, children: [variantSelector !== null && variantSelector !== void 0 ? variantSelector : null, filteredChildren] }) }) }), onlineShopping && _jsx(FlexGrid.Col, { md: 6, children: onlineShopping })] }) }) })] }));
};
// --------------------------- STYLES --------------------------- //
var OnlineShoppingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 -", "px;\n  @media (", ") {\n    margin: 0;\n  }\n"], ["\n  margin: 0 -", "px;\n  @media (", ") {\n    margin: 0;\n  }\n"])), space(3), fromTablet);
var templateObject_1;
